export var SubmissionStatus;
(function(SubmissionStatus) {
    SubmissionStatus["Idle"] = "idle";
    SubmissionStatus["AwaitingResponse"] = "awaiting-response";
    SubmissionStatus["Error"] = "error";
})(SubmissionStatus || (SubmissionStatus = {}));
export var SubmissionError;
(function(SubmissionError) {
    SubmissionError["Unknown"] = "unknown";
    SubmissionError["ForbiddenTermsInPrompt"] = "forbidden-terms";
    SubmissionError["NotEnoughStashSpace"] = "not-enough-stash-space";
    SubmissionError["NotEnoughPoints"] = "not-enough-points";
    SubmissionError["ValidationError"] = "validation-error";
})(SubmissionError || (SubmissionError = {}));
export var ArtStyle;
(function(ArtStyle) {
    ArtStyle["Default"] = "default";
    ArtStyle["Fantasy"] = "fantasy";
    ArtStyle["Anime"] = "anime";
    ArtStyle["Anthro"] = "anthro";
    ArtStyle["Photographic"] = "photographic";
    ArtStyle["Vaporwave"] = "vaporwave";
    ArtStyle["Lowpoly"] = "lowpoly";
    ArtStyle["Origami"] = "origami";
    ArtStyle["LineArt"] = "line_art";
    ArtStyle["CraftClay"] = "craft_clay";
    ArtStyle["Cinematic"] = "cinematic";
    ArtStyle["ThreeDModel"] = "3d_model";
    ArtStyle["PixelArt"] = "pixel_art";
})(ArtStyle || (ArtStyle = {}));
export var VariationSource;
(function(VariationSource) {
    VariationSource["Dreamup"] = "dreamup";
    VariationSource["MediaSelector"] = "media-selector";
})(VariationSource || (VariationSource = {}));

//# sourceMappingURL=types.js.map